import React, { memo, useCallback, useEffect, useState } from 'react'
import {
  useLocation
  // useSearchParams,
  // useNavigate
} from 'react-router-dom'
// import { useDispatch } from 'react-redux'

import PrivateRoute from './pravateRoute'
import DefaultLayout from '@/layout/DefaultLayout'

import { getOPageConfig } from './__const__/pageConfigs'
// import { setWxShare } from './__utils__/wxShare'

// 初始化埋点
const setMonitor = obj => {
  if (!obj) return
  const $monitor = window.$monitor
  $monitor.setConfig({
    module: obj.monitorModule,
    module_name: obj.monitorModuleName
    // openid: window.localStorage['openid']
    // title: '筷子科技'
  })
  $monitor.push({
    type: 'page'
  })
}
// 初始化网页标题
const setDocTit = obj => {
  if (!obj) return
  window.document.title = obj.documentTitle
}
// 手动添加mate标签
const setMate = (name, content) => {
  if (!name || !content) return
  let meta = document.querySelector(`meta[name=${name}]`)
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = name
  }
  meta.content = content
  document.getElementsByTagName('head')[0].appendChild(meta)
}

// 初始化网页描述
const setDescription = obj => {
  if (!obj || !obj.description) return
  setMate('description', obj.description)
}

// 路由拦截
const WrapperRouteComponent = ({ auth, ...props }) => {
  const location = useLocation()
  const [first, setFirst] = useState(false)
  // const [, setSearchParams] = useSearchParams()
  // const dispatch = useDispatch()
  // const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const a_keywordid = params.get('a_keywordid')
    const bd_vid = params.get('bd_vid')
    a_keywordid && sessionStorage.setItem('a_keywordid', a_keywordid)
    bd_vid && sessionStorage.setItem('bd_vid', bd_vid)
  }, [])

  useEffect(() => {
    if (window.location.href.includes('communal/aiMixCut')) {
      window.sessionStorage.removeItem('auth_token')
      window.localStorage.removeItem('token')
    }
    window.localStorage['innerOpenUrl'] = window.location.href
  }, [])

  useEffect(() => {
    if (!first) {
      setFirst(true)
      // mounted()
    }
  }, [first])

  useEffect(() => {
    const oPageConfig = getOPageConfig()
    setDocTit(oPageConfig) // 网页标题
    setMonitor(oPageConfig) // 页面埋点
    setDescription(oPageConfig) // 网页描述
    // setWxShare()
  }, [location.pathname])

  return (
    <>
      {auth ? (
        // 需要授权验证？此项目没有
        <PrivateRoute {...props} />
      ) : (
        <>
          <DefaultLayout>{props.element}</DefaultLayout>
        </>
      )}
    </>
  )
}

export default WrapperRouteComponent
